<template> 
 <v-container>
    <v-card>     
        <v-layout v-if="loading">
            <v-progress-linear color="primary" indeterminate></v-progress-linear>
        </v-layout>
        <v-layout wrap>
            <v-flex xs12>
                <v-layout>
                    <v-flex xs12>
                        <h1 class="text-xs-center">Assign to Stores</h1>
                    </v-flex>
                </v-layout>
                
                <v-layout wrap class="grid-actions">
                    <v-flex xs12 md8 offset-md2 xl4 offset-xl4>
                        <v-btn
                            color="success"
                            block
                            :disabled="selectedStores.length < 1 || selectedProductIDs.length < 1"
                            @click="saveAssignToAllStores()">
                            Assign to Selected Stores
                        </v-btn>
                    </v-flex>
                </v-layout>

                <v-layout wrap class="grid-actions" v-if="saveValidationErrors.length > 0">
                    <v-flex xs12 md8 offset-md2 xl4 offset-xl4 v-for="(errorMessage, index) in saveValidationErrors" :key="index">
                        <error-alert :content="errorMessage" :display="errorMessage"></error-alert>
                    </v-flex>
                </v-layout>
            </v-flex>

            <v-flex xs12>
                <v-layout wrap>
                    <v-flex xs12>
                        <v-combobox 
                            v-model="selectedStores" 
                            :items="availableStores" 
                            label="Stores" 
                            itemText="Name"
                            itemValue="ID"
                            clearable
                            multiple
                            @change="onSelectionChanged" >
                            <template slot="prepend-item">
                                <v-list-tile v-if="selectedStores.length > 0" @click="selectedStores = []">
                                    <v-list-tile-action>
                                    </v-list-tile-action>
                                    <v-list-tile-content>
                                        <v-list-tile-title>Deselect all</v-list-tile-title>
                                    </v-list-tile-content>
                                </v-list-tile>
                                <v-list-tile v-else @click="selectedStores = availableStores">
                                    <v-list-tile-action>
                                    </v-list-tile-action>
                                    <v-list-tile-content>
                                        <v-list-tile-title>Select all</v-list-tile-title>
                                    </v-list-tile-content>
                                </v-list-tile>
                            </template>
                        </v-combobox>
                    </v-flex>
                </v-layout>

                <div>
                    <div v-for="(product, index) in selectedProductIDs" :key="index">
                        <v-flex xs8 offset-xs2 my-4 v-if="index > 0">
                            <hr />
                        </v-flex> 
                        <v-layout>
                            <v-flex xs7 mx-2>
                                <div style="display: flex; flex-direction: row;">
                                    <v-autocomplete
                                        :items="products"
                                        :item-text="productName"
                                        v-model="selectedProductIDs[index]"
                                        item-value="ID"
                                        label="Product"
                                        hint="Product"
                                        returnObject
                                    ></v-autocomplete>
                                    <v-btn icon color="error" @click="removeProduct(index)" :disabled="index < 1">
                                        <v-icon>delete</v-icon>
                                    </v-btn>
                                </div>
                            </v-flex>
                            <v-flex xs5 mx-2>
                                <h3> Supplier List</h3>
                                <div v-for="(supplier, supplierIndex) in selectedProductIDs[index].suppliers" :key="index+'-'+supplierIndex">
                                    <div style="display: flex; flex-direction: row;">
                                        <v-autocomplete
                                            :items="suppliers"
                                            item-text="Name"
                                            item-value="ID"
                                            v-model="selectedProductIDs[index].suppliers[supplierIndex]"
                                        ></v-autocomplete>
                                        <v-btn icon color="error" @click="removesupplier(selectedProductIDs[index], supplierIndex)" :disabled="supplierIndex < 1">
                                            <v-icon>delete</v-icon>
                                        </v-btn>
                                    </div>
                                </div>
                                
                                <v-btn block color="success" @click="addSupplier(selectedProductIDs[index])" :disabled="selectedProductIDs[index] === -1">
                                    <span class="hidden-xs-only" >Add Supplier</span>
                                    <span class="hidden-sm-and-up">Add</span>
                                </v-btn>
                            </v-flex>
                        </v-layout>
                    </div>
                    
                    <v-flex xs6 md-3>
                        <v-btn block color="success" @click="addProduct()">
                            <span class="hidden-xs-only">Add Product</span>
                            <span class="hidden-sm-and-up">Add</span>
                        </v-btn>
                    </v-flex>
                </div>
            </v-flex>
        </v-layout>
    </v-card>
    
    <v-dialog v-model="showConfirmDialog">
        <v-card>
                <v-card-title class="headline">Please confirm to assign product to these stores?</v-card-title>
            <v-card-text>
                <v-layout wrap v-for="(confirmStore, confirmStoreIndex) in confirmStores" :key="confirmStoreIndex">
                    {{confirmStore.Name}}
                </v-layout>
            </v-card-text>
                <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                    color="red"
                    class="white--text"
                    @click="showConfirmDialog = false">
                    No
                </v-btn>
                <v-btn
                    color="green"  
                    class="white--text"
                    @click="confirmSaveAssignToStores()">
                    Yes
                </v-btn>
                </v-card-actions>
        </v-card>
    </v-dialog>
 </v-container>
</template>

<script>
import Vue from "vue";
import validationRules from "../../helpers/validationrules";
import formatters from "../../helpers/formatters";
import ErrorAlert from "../common/ErrorAlert"
import util from '@/services/util';
import auth from '@/services/auth';
import api from '@/services/api';
import _ from "underscore";

export default {
    components: {
        ErrorAlert
    },
    data() {
        return {
            saveValidationErrors: [],
            validationErrorProductIDs: [],
            assignToSuppliers: [],
            loading: false,
            rules: validationRules.rules,
            showConfirmDialog: false,
            confirmStores: [],

            selectedStores: [],
            selectedProductIDs: []
        };
    },
    computed: {
        suppliers() {
            return this.$store.state.supplierStore.suppliers.filter(s => s.Active);
        },
        categories() {
            return this.$store.state.categoryStore.categories.sort(util.sortByName);
        },
        products() {
            return this.$store.state.productStore.products.filter(s => s.Active).sort( (a, b) => {
                 if(a.CategorySortOrder > b.CategorySortOrder) {
                    return 1
                } else if(a.CategorySortOrder < b.CategorySortOrder) {
                    return -1
                } else {
                    return a.Name.toUpperCase().localeCompare(b.Name.toUpperCase());
                }
            });
        },
        availableStores() {
            var stores = this.$store.state.storeStore.stores.filter(s => s.Active && auth.hasAccessToStore(s.ID));
            this.selectedStores = stores;
            // return actual store objects, so that we have the appropriate data required for the page
            return stores;
        }
    },
    methods: {
        onSelectionChanged(){
            // repopulate data based on the selected store
            if (this.selectedStores.length === 0) {
                console.log("no stores selected");
            } else {
               console.log("stores selected > 0");
               this.loadProducts();
               this.loadCategories();
               this.loadSuppliers();
            }
        },
        loadStores() {
            this.$store.dispatch("storeStore/loadStores");
        },
        loadProducts() {
            if (this.selectedStores.length !== 1) {
                this.$store.dispatch("productStore/loadProducts");
            } else {
                console.log('prod-StoreId: ' + this.selectedStores[0].ID);
                let currentStoreID = this.selectedStores[0].ID;
                this.$store.dispatch("productStore/loadProductsByStore", {storeID: currentStoreID});
            }
        },
        loadCategories() {
            if (this.selectedStores.length !== 1) {
                this.$store.dispatch("categoryStore/loadCategories");
            } else {
                console.log('catg-StoreId: ' + this.selectedStores[0].ID);
                let currentStoreID = this.selectedStores[0].ID;
                this.$store.dispatch("categoryStore/loadCategoriesByStore", {storeID: currentStoreID});
            }
        },
        loadSuppliers() {
            if (this.selectedStores.length !== 1) {
                this.$store.dispatch("supplierStore/loadSuppliers");
            } else {
                console.log('supp-StoreId: ' + this.selectedStores[0].ID);
                let currentStoreID = this.selectedStores[0].ID;
                this.$store.dispatch("supplierStore/loadSuppliersByStore", {storeID: currentStoreID});
            }
            //this.$store.dispatch("supplierStore/loadSuppliersAll", {allSuppliers: 'true'});
        },
        productName(item) {
            return item.CategoryName ? (item.CategoryName + ' - ' + item.Name) : item.Name;
        },
        saveAssignToAllStores() {
            if(this.validateData()) {
                //Show confirmation popup
                this.showConfirmDialog = true;
            }
        },
        confirmSaveAssignToStores() {
            this.loading = true;
            this.saveValidationErrors = [];
            var that = this;
            var productsuppliers = {};
            for (let i = 0; i < this.selectedProductIDs.length; i++) {
                console.log(i, this.selectedProductIDs[i])
                const product = this.selectedProductIDs[i];
                productsuppliers[product.ID] = { 
                    suppliers: product.suppliers.map(supplier=> {
                        return {SupplierID: supplier}
                    }) 
                }
            }
            api.assignToStores(
                {
                    storeIDs: this.selectedStores.map(store=> {
                        return store.ID;
                    }),
                    data: productsuppliers
                },
                {
                success: function(response) {
                    console.log(response);
                    /*
                     that.$router.push({
                        path: "/"
                    });
                    */
                }, 
                error: function(e) {
                    that.saveValidationErrors.push(api.parseHttpRequestError(e));
                },  
                finally: function() {
                    that.loading = false;
                }});
            this.showConfirmDialog = false;
        },
        addProduct() {
            this.selectedProductIDs.push(-1)
        },
        removeProduct(productIndex) {
            this.selectedProductIDs.splice(productIndex, 1);
        },
        addSupplier(targetProduct) {
            console.log('add supplier fn', targetProduct)
            if(targetProduct.suppliers === undefined){
                Vue.set(targetProduct, 'suppliers', [ -1 ] )
                return
            }
            targetProduct.suppliers.push(-1);
            Vue.set(targetProduct, 'suppliers', targetProduct.suppliers)
        },
        removesupplier(targetProduct, supplierIndex) {
            console.log('remove supplier fn', targetProduct)
            targetProduct.suppliers.splice(supplierIndex, 1)
            Vue.set(targetProduct, 'suppliers', targetProduct.suppliers)
        },
        validateData() {
            this.saveValidationErrors = [];
            this.validationErrorProductIDs = [];
               
            let suppliers = [];

            for (let i = 0; i < this.selectedProductIDs.length; i++) {
                const product = this.selectedProductIDs[i];
                if(product == -1) {
                    this.saveValidationErrors.push("Product must have a value");
                    this.saveValidationErrors.push("You must select at least one supplier to assign for each product");
                    continue;
                }
                if(product.suppliers === undefined) {
                    this.saveValidationErrors.push("You must select at least one supplier to assign for each product");
                }
                suppliers = suppliers.concat(product.suppliers)
            }

            // loop through all suppliers
            for (let i=0; i<suppliers.length; i++) {
                let supplier = suppliers[i];
                
                if (supplier < 0) {
                    this.saveValidationErrors.push("Supplier cannot be blank. Ensure all supplier fields have a value");
                } 
            }

            if (this.saveValidationErrors.length > 0) {
                return false;
            }
            return true;
        }
    },
    created() {
        this.loadStores();
        this.loadProducts()
        this.loadCategories();
        this.loadSuppliers();
    }
}
</script>

<style>

    .product-container .flex {
        padding: 5px;
    }

    .product-container.even {
        background-color: #f2f2f2;
    }

    .product-container.validation-error {
        border: 5px solid #e57373;
    }
</style>
